import { parse as parseCookie } from 'cookie'
import { DomainError } from '../_kernel/DomainError'
import { ErrorsCode } from '../_kernel/ErrorsCode'

export type Response<T> = [DomainError, undefined] | [undefined, T | undefined]

export abstract class Cookie {
  protected cookieParsed: Record<string, string | undefined> | undefined

  abstract save<T extends string>({ key, value }: { key: string; value: string }): Response<T>

  abstract decode<T extends string>({ value }: { value: string }): T

  get<T extends string>({ key, encoding }: { key: string; encoding?: 'base64' }): Response<T> {
    const decodeFn =
      encoding === 'base64' ? this.decode : ({ value }: { value: string }) => value as T

    if (this.cookieParsed?.[key]) return [undefined, decodeFn({ value: this.cookieParsed[key]! })] // eslint-disable-line

    return [DomainError.withCodes(ErrorsCode.COOKIE_NOT_FOUND), undefined]
  }

  parse({ cookie }: { cookie: string }) {
    if (this.cookieParsed) return this.cookieParsed

    this.cookieParsed = parseCookie(cookie)

    return this.cookieParsed
  }
}
